import { render, staticRenderFns } from "./Agency.vue?vue&type=template&id=ca5b2846&scoped=true"
import script from "./Agency.vue?vue&type=script&lang=js"
export * from "./Agency.vue?vue&type=script&lang=js"
import style0 from "./Agency.vue?vue&type=style&index=0&id=ca5b2846&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5b2846",
  null
  
)

export default component.exports